import { Helmet } from "react-helmet-async";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Header } from "@/components/Header";
import { KnowledgeConnections } from "@/components/knowledge/KnowledgeConnections";
import { Footer } from "@/components/Footer";
import { BreadcrumbNav } from "@/components/BreadcrumbNav";
import { JsonLd } from "@/components/JsonLd";
import { generateCanonicalUrl } from "@/utils/seoHelpers";

const GoogleAdsKatyPage = () => {
  const [language, setLanguage] = useState<'es' | 'en'>('es');
  const toggleLanguage = () => setLanguage(language === 'es' ? 'en' : 'es');
  const canonicalUrl = generateCanonicalUrl('/google-ads-katy');

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Google Ads en Katy TX",
    "provider": { "@id": "https://luisroc.com/#organization" },
    "areaServed": { "@type": "City", "name": "Katy" }
  };

  return (
    <>
      <Helmet>
        <html lang={language} />
        <title>Google Ads Katy TX | Campañas PPC Locales – Luis ROC</title>
        <meta name="description" content="Campañas Google Ads en Katy, TX. Activa demanda mediante campañas pagadas con segmentación local. Reunión inicial gratuita." />
        <meta name="keywords" content="google ads katy tx, ppc katy" />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      <JsonLd data={serviceSchema} />

      <div className="min-h-screen bg-background">
        <Header language={language} onLanguageChange={toggleLanguage} />
        
        <main className="container mx-auto px-4 py-8">
          <BreadcrumbNav 
            items={[
              { name: "Servicios", url: "/servicios" },
              { name: "Localidades", url: "/servicios-locales-houston" },
              { name: "Google Ads Katy", url: "/google-ads-katy" }
            ]}
            language="es"
          />

          <section className="py-16 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Google Ads en Katy TX — Demanda activada mediante campañas pagadas
            </h1>
            
            <p className="text-lg text-muted-foreground max-w-3xl mx-auto mb-8">
              Campañas PPC optimizadas para Katy con segmentación precisa y medición orientada a negocio.
            </p>

            <Button size="lg" onClick={() => window.location.href = '/contacto'}>
              Reunión inicial gratuita de 30 minutos
            </Button>
          </section>
        </main>

        <KnowledgeConnections path="/google-ads-katy" language={language} />

        <Footer language={language} />
      </div>
    </>
  );
};

export default GoogleAdsKatyPage;
